<template>
    <div class="bgc">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" >
          <!-- 下拉刷新 -->
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            loading-text="正在加载中..."
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="onLoad"
            :immediate-check="false"
          >
            <!-- 上拉加载 -->
            <ul class="order_list">
              <li class="order_item" v-for="(item,index) in dataList" :key="index">
                <div class="order_sn">
                  <p>售后编号：{{item.returnSn }}</p>
                  <div class="order_status">
                      <template v-if="item.type==1 || item.type==2">
                          <template v-if="item.status===1">退款-待处理</template>
                          <template v-if="item.status===2">退款-已通过</template>
                          <template v-if="item.status===3">退款-已拒绝</template>
                          <template v-if="item.status===4">退款-处理中</template>
                          <template v-if="item.status===5">退款-已完成</template>
                      </template>
                      <template v-if="item.type==3">
                          <template v-if="item.status===1">退货-待处理</template>
                          <template v-if="item.status===2">退货-已通过</template>
                          <template v-if="item.status===3">退货-已拒绝</template>
                          <template v-if="item.status===4">退货-处理中</template>
                          <template v-if="item.status===5">退货-已完成</template>
                      </template>
                  </div>
                </div>
                <!-- 商品明细 -->
                <div class="shop_detail" @click="gospeed(item)" v-if="item.type!=1">
                  <div class="detail">
                    <div class="image">
                      <img :src="item.productPic" />
                    </div>
                    <div class="right">
                      <div class="box">
                        <div class="text_1">
                          {{item.productName}}
                        </div>
                        <div class="text_2">{{item.productAttr}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="rietagdilht"><van-icon name="arrow" /></div>
                </div>
                <!-- 商品明细 -->
                <div v-if="item.type==1">
                    <loading :item="item.orderId" />
                </div>
                <div class="total">{{item.createTime}}</div>
              </li>
            </ul>
          </van-list>
        </van-pull-refresh>
    </div>
</template>
<script>
import { List, PullRefresh, Empty, Icon } from 'vant'
import { afterList } from '@/request/api'
import loading from './props'
export default {
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Empty.name]: Empty,
    [Icon.name]: Icon,
    loading
  },
  data() {
    return {
      error: false,
      dataList: [], // 请求数据
      loading: false, // 上拉加载
      finished: false, // 上拉加载完毕
      isLoading: false, // 下拉刷新
      pageNum: 1 // 页码
    }
  },
  methods: {
    onRefresh () {
      setTimeout(() => {
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.isLoading = false
        this.onLoad()
      }, 1000)
    },
    gospeed(i) {
      console.log(i)
      this.$router.push({ path: '/Speed', query: { id: i.id } })
    },
    onLoad () {
      if (this.dataList.length < 4) {
        this.finished = true
        return false
      }
      this.pageNum += 1
      console.log(this.pageNum)
      afterList({ pageSize: 10, pageNum: this.pageNum }).then(res => {
        if (res.code === 200) {
          console.log(res)
          setTimeout(() => {
            this.dataList = this.dataList.concat(res.data.list)
            this.loading = false
            console.log(this.dataList)
            if (this.dataList.length >= res.data.total) {
              this.finished = true
            }
          }, 1000)
        } else {
          this.loading = false
          this.error = true
        }
      }).catch(res => {
        console.log(res)
      })
    }
  },
  created() {
    afterList({ pageSize: 10, pageNum: 1 }).then(res => {
      console.log(res)
      this.dataList = res.data.list
      this.dataList.map((item, index) => {
        if (item.type === 1) {
          console.log(item)
        //   afterInfo({returnId:item.})
        }
      })
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>
<style lang="less" scoped>
.bgc{
    min-height: 100vh;
    background-color: #F2F2F2;
}
.total{
    margin-bottom: 20px;
}
.order_list {
  width: 100%;
  overflow: hidden;
}
/* 订单列表渲染 */
.order_list .order_item {
  width: 100%;
  padding-left: 32px;
  margin: 20px 0 0;
  background: #fff;
  overflow: hidden;
  position: relative;
}
.order_list .order_item .order_sn {
  float: left;
  width: 100%;
  color: #333;
  font-size: 28px;
  line-height: 1;
  padding: 24px 0 30px;
  border-bottom: 1px solid rgba(218, 218, 218, 1);
}
.order_list .order_item .order_sn p {
  float: left;
}
.order_list .order_item .order_status {
  float: left;
  color: #aa2832;
  font-size: 24px;
  padding-left: 24px;
}
.order_list .order_item .count_down {
  float: right;
  text-align: right;
  display: block;
  /* width: 100%; */
  font-size: 20px;
  color: rgba(170, 40, 50, 1);
  padding-top: 8px;
  padding-right: 30px;
}
.order_list .order_item .shop_detail {
  width: 100%;
  padding: 24px 0 10px;
  overflow: hidden;
  position: relative;
}
.order_list .order_item .shop_detail .detail {
  float: left;
}
.order_list .order_item .shop_detail .detail .image {
  float: left;
  width: 140px;
  height: 140px;
  margin-right: 42px;
  position: relative;
}
.order_list .order_item .shop_detail .detail .image.active {
  margin-right: 14px;
}
.order_list .order_item .shop_detail .detail .image img {
  float: left;
  width: 140px;
  height: 140px;
}
.order_list .order_item .shop_detail .detail .image div {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 24px;
  color: rgba(255, 255, 255, 1);
  background: rgba(180, 39, 45, 1);
  position: absolute;
  left: 0;
  bottom: 0;
}
.order_list .order_item .shop_detail .detail .right {
  float: left;
  width: 390px;
}
.order_list .order_item .shop_detail .detail .right .box .text_1 {
  color: #333;
  font-size: 28px;
  line-height: 36px;
  padding: 8px 0 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .abroad,
  .autark {
    float: left;
    width: 76px;
    height: 38px;
    line-height: 34px;
    text-align: center;
    font-size: 24px;
    border-radius: 6px;
    font-weight: 400;
    margin-right: 6px;
  }
}
.order_list .order_item .shop_detail .detail .right .box .text_2 {
  color: #666;
  font-size: 22px;
  line-height: 26px;
}
.rietagdilht{
    position: absolute;
    right: 60px;
    top: 100px;
}
</style>
